import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, Optional, NgModule, SkipSelf } from '@angular/core';
import { isBrowser } from '@rogers/cdk/common/utils';
import { BehaviorSubject } from 'rxjs';
import * as i2 from '@rogers/cdk/common/services';

class CDKCoreConfig {
    constructor(config) {
        this.mode = 'light';
        this.brand = config?.brand;
        this.mode = config?.mode || 'light';
    }
}

var name = "@rogers/cdk";
var version = "2.1.4";
var pkg = {
	name: name,
	version: version
};

let CDKCoreStatic = {
    brand: 'rogers',
};
class CDKCoreService {
    constructor(_config, analyticsService) {
        this._config = _config;
        this.analyticsService = analyticsService;
        this.config$ = new BehaviorSubject(new CDKCoreConfig({}));
        this.config$.next(new CDKCoreConfig(this._config));
        this.analyticsService.injectVersion({
            name: pkg.name,
            version: pkg.version,
        });
        this.setGlobalTheme();
    }
    set(config) {
        this.config$.next({ ...this.config$.getValue(), ...config });
        CDKCoreStatic.brand = this.brand;
        this.setGlobalTheme();
    }
    get brand() {
        return this.config$.getValue()?.brand;
    }
    setGlobalTheme() {
        if (isBrowser()) {
            const root = document.querySelector(':root');
            root.setAttribute('theme', this.brand);
            const body = document.body;
            body.setAttribute('mode', this.config$.getValue().mode);
        }
    }
}
CDKCoreService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CDKCoreService, deps: [{ token: CDKCoreConfig, optional: true }, { token: i2.AnalyticsService }], target: i0.ɵɵFactoryTarget.Injectable });
CDKCoreService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CDKCoreService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CDKCoreService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: CDKCoreConfig, decorators: [{
                    type: Optional
                }] }, { type: i2.AnalyticsService }]; } });

class CDKCoreModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('CDKCoreModule is already loaded. Import it in the AppModule only');
        }
    }
    static forRoot(config) {
        return {
            ngModule: CDKCoreModule,
            providers: [
                {
                    provide: CDKCoreConfig,
                    useValue: config,
                },
            ],
        };
    }
}
CDKCoreModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CDKCoreModule, deps: [{ token: CDKCoreModule, optional: true, skipSelf: true }], target: i0.ɵɵFactoryTarget.NgModule });
CDKCoreModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CDKCoreModule, imports: [CommonModule] });
CDKCoreModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CDKCoreModule, providers: [CDKCoreService], imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CDKCoreModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [CommonModule],
                    providers: [CDKCoreService],
                }]
        }], ctorParameters: function () { return [{ type: CDKCoreModule, decorators: [{
                    type: Optional
                }, {
                    type: SkipSelf
                }] }]; } });

/**
 * Generated bundle index. Do not edit.
 */

export { CDKCoreConfig, CDKCoreModule, CDKCoreService, CDKCoreStatic };
